import React from 'react';

import { JournalEvents } from 'modules';
import { useRequiredParams } from 'utils';
import { PageSpinner, Title, VerticalLayout } from 'widgets';

import { usePersonOrgProfile } from './person-queries';

export const JournalTab = () => {
    const { personOrgGUID } = useRequiredParams(['personOrgGUID']);
    const { data: existingPerson } = usePersonOrgProfile(personOrgGUID);

    return (
        <VerticalLayout $gap={16}>
            <Title section>Journal</Title>

            {!existingPerson ? <PageSpinner /> : <JournalEvents personOrgGUID={existingPerson?.personOrgGUID} />}
        </VerticalLayout>
    );
};
